export default import.meta.ROLLDOWN_FILE_URL_8lnMzLjAb2LTrg_7oX19hw